module.exports = __webpack_public_path__ + "static/media/groomingBanner2.f01b2943.png";